import Tooltip from "../../common/StyledToolTip";
function TerminalMarker(props) {
  return (
    <Tooltip
      title={
        props.data ? (
          <div>
            {props.data.name}
            <br />
            {props.data.address}
          </div>
        ) : (
          ""
        )
      }
    >
      <svg
        width={props.data?.size || "40"}
        height={props.data?.size || "40"}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="14.8491"
          y="0.707107"
          width="20"
          height="20"
          rx="1.5"
          transform="rotate(45 14.8491 0.707107)"
          fill={props.fillColor || "#AAAEB3"}
        />
        <path
          d="M15.9087 20.3491H13.7896V12.1187H11.0757V10.355H18.6226V12.1187H15.9087V20.3491Z"
          fill={props.color || "#000000"}
        />
        <rect
          x="14.8491"
          y="0.707107"
          width="20"
          height="20"
          rx="1.5"
          transform="rotate(45 14.8491 0.707107)"
          stroke={props.color || "#000000"}
        />
      </svg>
    </Tooltip>
  );
}

export default React.memo(TerminalMarker);
